export default __webpack_public_path__ + "static/Branding-becfaf0a9d4de5ad615061609754a513.png";